import { npsApis, parentApis } from '@shared/apis';
import {
  genericMutation,
  genericMutationWithId,
  genericQueryWithIdAndParams,
  genericQueryWithParams,
} from './generics';

export const useStudentData = genericQueryWithParams<parentApis.GetStudentData>(
  parentApis.getStudentData
);

export const useCheckParentPendingNPS = genericQueryWithIdAndParams<npsApis.CheckParentPendingNPS>(
  npsApis.checkParentPendingNPS,
  { retry: false }
);

export const useSubmitParentNPS = genericMutation<npsApis.SubmitParentNPS>(
  npsApis.submitParentNPS,
  npsApis.checkParentPendingNPS.endpoint
);

export const useReportParentIssue = genericMutation<parentApis.ReportParentIssue>(
  parentApis.reportParentIssue
);

export const useGetStudentBannerDetails =
  genericQueryWithParams<parentApis.GetStudentBannerDetails>(parentApis.getStudentBannerDetails);

export const useGetOverviewFeedbackAvg = genericQueryWithParams<parentApis.FeedbackOverview>(
  parentApis.feedbackOverview
);

export const useGetParentViewCoursesInProgress =
  genericQueryWithParams<parentApis.GetParentViewCoursesInProgress>(
    parentApis.getParentViewCoursesInProgress
  );

export const useGetParentViewEnrollmentTimeline =
  genericQueryWithParams<parentApis.GetParentViewEnrollmentTimeline>(
    parentApis.getParentViewEnrollmentTimeline
  );

export const useGetParentViewUpcomingCourses =
  genericQueryWithParams<parentApis.GetParentViewUpcomingCourses>(
    parentApis.getParentViewUpcomingCourses
  );

export const useGetParentViewCompletedCourses =
  genericQueryWithParams<parentApis.GetParentViewCompletedCourses>(
    parentApis.getParentViewCompletedCourses
  );

export const useGetParentViewUpcomingStudentMeetings =
  genericQueryWithParams<parentApis.UpcomingStudentMeetings>(parentApis.upcomingStudentMeetings);

export const useGetParentViewUniversitiesApplyingTo =
  genericQueryWithParams<parentApis.GetParentViewUniversitiesApplyingTo>(
    parentApis.getParentViewUniversitiesApplyingTo
  );

export const useGetParentViewSessionDetails =
  genericQueryWithIdAndParams<parentApis.GetStudentSessionDetails>(
    parentApis.getStudentSessionDetails
  );

export const useGetParentFeedbackSessions =
  genericQueryWithIdAndParams<parentApis.GetParentFeedbackSessions>(
    parentApis.getParentFeedbackSessions
  );

export const useRegisterParentFeedback = genericMutationWithId<parentApis.RegisterParentFeedback>(
  parentApis.registerParentFeedback,
  parentApis.getParentViewCoursesInProgress.endpoint,
  parentApis.getParentViewCompletedCourses.endpoint,
  parentApis.getStudentSessionDetails.endpoint,
  parentApis.hasSessionParentFeedback.endpoint
);

export const useGetEnrollmentSurveyType =
  genericQueryWithParams<parentApis.GetEnrollmentSurveyType>(parentApis.getEnrollmentSurveyType);
export const useHasSessionParentFeedback =
  genericQueryWithParams<parentApis.HasSessionParentFeedback>(parentApis.hasSessionParentFeedback);

export const useGetParentWhatsAppGroups =
  genericQueryWithParams<parentApis.GetParentWhatsAppGroups>(parentApis.getParentWhatsAppGroups);

export const useSetParentWhatsAppGroupJoined =
  genericMutation<parentApis.SetParentWhatsAppGroupJoined>(
    parentApis.setParentWhatsAppGroupJoined,
    parentApis.getParentWhatsAppGroups.endpoint
  );

export const useDismissParentWhatsAppReminder =
  genericMutation<parentApis.DismissParentWhatsAppReminder>(
    parentApis.dismissParentWhatsAppReminder,
    parentApis.getParentWhatsAppGroups.endpoint
  );
